<script lang="ts" setup>
import axios from "axios";
import { ref, defineProps } from "vue";

import PaymentMethodWidget from "@/UI/widgets/PaymentMethodWidget.vue";
import BusyOverlay from "@/UI/widgets/BusyOverlay.vue";

let props = defineProps({
  userCards: Array
});

let paymentMethodWidget = ref();
let isSending = ref(false);
let output = ref<string | null>(null);

function handleCheckoutClick() {
  isSending.value = true;

  paymentMethodWidget.value.requestPaymentMethod()
    .then((payment: any) => {
      axios
        .post('/sandbox/checkout', {
          payment: {
            token: payment?.nonce,
            method: payment?.type,
          }
        })
        .then((response) => {
          output.value = JSON.stringify(response.data);
        })
        .finally(() => {
          isSending.value = false;
        });
    });
}
</script>

<template>
  <div>
    <h4>1$ test</h4>

    <BusyOverlay :is-showing="isSending">
      <div v-if="output">
        {{ output }}
      </div>
      <div v-else>
        <PaymentMethodWidget
          ref="paymentMethodWidget"
          :user-cards="props.userCards"
        />

        <button
          class="btn btn-primary"
          @click="handleCheckoutClick"
        >
          CHECKOUT
        </button>
      </div>
    </BusyOverlay>
  </div>
</template>

<style lang="scss" scoped>

</style>
